<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Pages statiques</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-container>
          <v-alert :type="messageType" v-if="message">{{message}}</v-alert>
          <v-row>
            <v-col>
              <v-text-field v-model="page.name" label="Nom de la page" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="page.slug" label="Url de la page" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-capitalize overline text--secondary">Contenu</div>
              <editor v-model="page.content" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onSubmit()">Sauver</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Editor from "@/components/Editor.vue";
export default {
  components: {
    Editor
  },
  data: () => ({
    pageId: null,
    success: false,
    message: null
  }),
  computed: {
    ...mapGetters("static", ["page"]),
    messageType: function() {
      if (this.success) {
        return "success";
      } else {
        return "error";
      }
    }
  },
  mounted: function() {
    this.initialize();
  },
  beforeDestroy() {
    this.cleanState();
  },
  methods: {
    ...mapActions("static", {
      getPage: "get",
      create: "create",
      update: "update",
      cleanState: "clean"
    }),
    initialize() {
      if (this.$route.params.id) {
        this.pageId = parseInt(this.$route.params.id);
        this.getPage(this.pageId);
      }
    },
    onSubmit() {
      let method = null;
      if (this.page.id) {
        method = this.update;
      } else {
        method = this.create;
      }
      method(this.page).then(() => {
        this.success = true;
        this.message = "Page sauvegardée";
      });
    }
  }
};
</script>

<style>
</style>